import axios from "axios";
import { buildAuthHeaders } from "../utils/authToken";

function resolveApiBaseUrl() {
  const raw = String(process.env.REACT_APP_BACKEND_BASE_URL || "").trim();
  return raw
    .replace(/^https?:\/\/www\.gpsfinvest\.com(?=\/|$)/i, "https://gpsfinvest.com")
    .replace(/\/+$/, "");
}

const BASE = resolveApiBaseUrl();

/**
 * Admin: create BSE UCC + platform client user in one step.
 * Auth header is sent when available but not required (matches other admin UCC APIs).
 */
export const adminOnboardUcc = (payload) => {
  const headers = {
    "Content-Type": "application/json",
    ...buildAuthHeaders({ admin: true }),
  };
  // Canonical path under /api/admin (no JWT middleware).
  return axios.post(`${BASE}/admin/ucc/onboard`, payload, {
    headers,
    withCredentials: true,
  });
};
